module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_01_6NV26_1SA_GSK.10a7681e.png";